module.exports = __webpack_public_path__ + "img/addIcon.6e024c7a.svg";